export type CaptchaProvider = 'yandex' | 'tencent';

export type CaptchaResult =
  | { provider: 'yandex'; token: string }
  | { provider: 'tencent'; ticket: string; randstr: string };

export interface CaptchaHandle {
  /** trigger the (invisible) challenge; result arrives via onSuccess */
  execute: () => void;
  /** drop any token and remount the widget (after a failure) */
  reset: () => void;
}

/** The exact POST-body shape the backend reads for each provider. */
export type CaptchaBody =
  | {
      captchaProvider: 'tencent';
      captchaTicket: string;
      captchaRandstr: string;
    }
  | { captchaProvider: 'yandex'; captchaToken: string };

/** Serialize a normalized result into the POST body fields the backend reads. */
export function captchaResultToBody(result: CaptchaResult): CaptchaBody {
  return result.provider === 'tencent'
    ? {
        captchaProvider: 'tencent',
        captchaTicket: result.ticket,
        captchaRandstr: result.randstr,
      }
    : { captchaProvider: 'yandex', captchaToken: result.token };
}
